import { v4 as uuidv4 } from 'uuid'

import { cloneElementForPDF } from '../../../../helpers/pdf'

import { PAGE_WRAPPER_TITLE_CLASSNAME, SECTION_HEADER_CONTAINER_CLASSNAME } from '../../../../constants/pdf'

const splitListByPages = (splittedByPage, sectionId, header) => {
  const splittedListItems = []
  splittedByPage.forEach((page, index) => {
    const newList = cloneElementForPDF(`${sectionId} ul`, `${sectionId.slice(1)}-${uuidv4()}`)
    newList.innerHTML = ''

    for (const li of page) {
      newList.appendChild(li)
    }

    if (index === 0) {
      // first page has header with section title
      const wrapper = document.createElement('div')
      wrapper.className = 'temporary-pdf-wrapper'
      // move element out of the visible screen
      wrapper.style.position = 'absolute'
      wrapper.style.minWidth = '1300px'
      wrapper.style.left = `-10000px`

      header && wrapper.appendChild(header)
      wrapper.appendChild(newList)
      document.body.appendChild(wrapper)

      splittedListItems.push(wrapper)
    } else {
      splittedListItems.push(newList)
    }
  })

  return splittedListItems
}

// the idea of this function is to get section which has one or multiple <List /> component rendered inside
// if List components has more list items then chunkSize split it to according amount items
// to fit the list on one PDF page and void cutting list items in unexpected places
export const getSectionSplitByPage = (sectionId, listItemSelector, chunkSize, processListItems = null) => {
  const section = document.querySelector(sectionId)
  if (!section) return []

  const newUl = section.cloneNode(true)

  if (processListItems) {
    processListItems(newUl)
  }

  // one section could have multiple lists
  const sectionLists = newUl.querySelectorAll(`${sectionId} ul`)

  const sectionListsSplittedByPages = []
  sectionLists.forEach((list, index) => {
    // split each list into pages
    const splittedByPage = []

    const tableListItems = Array.from(list.querySelectorAll(listItemSelector))
    for (let i = 0; i < tableListItems.length; i += chunkSize) {
      splittedByPage.push(tableListItems.slice(i, i + chunkSize))
    }

    const headerNode =
      document.querySelector(`${sectionId} [class^="${SECTION_HEADER_CONTAINER_CLASSNAME}"]`) ||
      document.querySelector(`${sectionId} [class^="${PAGE_WRAPPER_TITLE_CLASSNAME}"]`)
    // show header only for first list
    const showHeader = index === 0
    const header = showHeader && headerNode?.cloneNode(true)

    sectionListsSplittedByPages.push(splitListByPages(splittedByPage, sectionId, header))
  })

  // as each list could have multiple pages, we need to flatten array so as a result we return list of elements to screenshot
  return sectionListsSplittedByPages.flat()
}
